import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { profileAccountService } from "../../../store/actions";
import { Modal } from "react-bootstrap";

interface DeleteTagModalProps {
    show: boolean;
    onClose: () => void;
    tagItem: TransactionTag;
    onSuccess: () => void;
}
interface TransactionTag {
    tag_name: string;
    transaction_hash: string;
    id: string;
}



const DeleteModal:FC<DeleteTagModalProps> = ({show,onClose,tagItem,onSuccess}) => {
    const [hash, setHash] = useState(tagItem.transaction_hash);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const _account = useSelector((e: Object) => (e as any)?.common?.account);
    const signature = _account?.signature;
    const message = _account?.message;
    const handleSubmit = async () => {
        if (!tagItem.transaction_hash) {
          setError('Invalid address details');
          return;
        }
 
        try {
          setIsSubmitting(true);
          setError(null);
    
          await profileAccountService.deleteTransactionTag({
          tagId:tagItem.id,
            message,
            signature,
          });
    
          onSuccess();
          onClose();
        } catch (err) {
          console.error('Error updating tag:', err);
          setError('Failed to update tag. Please try again.');
        } finally {
          setIsSubmitting(false);
        }
    };
    if (!show) return null;

    
  return (
    <Modal show={show} onHide={onClose} animation={true}>
          <Modal.Header closeButton>
      <Modal.Title>
        <h5 className="modal-title fw-medium">Confirmation Required</h5>
      </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
      <div className="row">
        <div className="col-lg-12">
          <p>Are you sure you wish to remove the address tag?</p>
          <h1>{tagItem.transaction_hash}</h1>
          
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
      </Modal.Body>
      
      <Modal.Footer className="bg-light">
      <button 
        className="btn btn-ghost-white" 
        onClick={onClose} 
        disabled={isSubmitting}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Deleting...' : 'Delete'}
      </button>
    </Modal.Footer>
      </Modal>
  );
}

export default DeleteModal
